import React, { useState } from 'react';
import { authService } from '../../api';
import { Link, useNavigate } from 'react-router-dom';
import './Connexion.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const response = await authService.forgotPassword(email);
      
      if (response.success) {
        setSuccess(response.message || 'Un lien de réinitialisation a été envoyé à votre adresse email.');
        setTimeout(() => {
          navigate('/connexion');
        }, 3000);
      } else {
        setError(response.message || 'Une erreur est survenue.');
      }
    } catch (err) {
      setError(err.message || 'Une erreur est survenue.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <Link to="/" className="home-arrow">
        <div className="arrow-icon">←</div>
      </Link>
      <div className="login-card">
        <h2 className="login-title">Mot de passe oublié</h2>
        <p className="forgot-password-subtitle">
          Entrez votre adresse email pour recevoir un lien de réinitialisation.
        </p>

        {error && <div className="login-error">{error}</div>}
        {success && <div className="login-success">{success}</div>}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="input-field">
            <label className="input-label">Adresse email *</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="login-input"
              required
              placeholder="votre@email.com"
            />
          </div>
          
          <button 
            type="submit" 
            className="login-button"
            disabled={loading}
          >
            {loading ? 'Envoi en cours...' : 'Envoyer le lien'}
          </button>
        </form>

        <div className="login-footer">
          <p>
            <button 
              className="login-linkbtn"
              onClick={() => navigate('/connexion')}
            >
              ← Retour à la connexion
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;